import { useState } from 'react';

export const useModalSellerVerification = () => {
  const [isOpenSellerVerification, setOpenSellerVerification] = useState(false);
  const [isOpenExistingModal, setIsOpenExistingModal] = useState(false);
  const [phone, setPhone] = useState('');

  const toggleSellerVerification = () => {
    setOpenSellerVerification(!isOpenSellerVerification);
  };

  const toggleExistingModal = () => {
    setIsOpenExistingModal(!isOpenExistingModal);
  };

  return {
    isOpenSellerVerification,
    isOpenExistingModal,
    phone,
    setOpenSellerVerification,
    setIsOpenExistingModal,
    setPhone,
    toggleSellerVerification,
    toggleExistingModal,
  };
};
